import styled from 'styled-components';

export const Container = styled.div`
  height: calc(100vh - 395px);
  display: flex;
  justify-content: center;
  align-items: center;
`;
